var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageLoader"},[_c('div',{staticClass:"popup_in center"},[_c('vue-loaders-ball-rotate',{attrs:{"color":"#30448d"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }